import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Paper, Typography } from '@mui/material';

import Chart from './BarChart';
import useStyles from './styles';

interface Props {
    hideFullList?: boolean;
    className?: string;
}

const Social: React.FC<Props> = ({ hideFullList, className }) => {
    const { classes, cx } = useStyles();

    return (
        <Paper elevation={0} className={cx(classes.root, className)}>
            <Box display="flex" flexDirection="row" alignItems="flex-end" justifyContent="space-between">
                <Typography variant="h4" className={classes.title}>
                    {'Discussed in social networks'}
                </Typography>
                {hideFullList ? null : (
                    <Link
                        to="search?query=enchantments.reddit:*%20last%2030%20days%20order:enchantments.reddit.counter"
                        className="vulners-link-initial"
                    >
                        <Typography variant="body2" className={classes.fullList}>
                            {'full list'}
                        </Typography>
                    </Link>
                )}
            </Box>

            <p className={classes.description}>
                {'Most discussed vulnerabilities in social networks in recent time divided by id'}
            </p>

            <div className={classes.chart}>
                <Chart />
            </div>
        </Paper>
    );
};

export default Social;
